import { el } from "../utils/dom";
import {
  absoluteTimeParts,
  duration,
  relativeTime,
  EMPTY,
  type AbsoluteTimeOptions,
} from "../utils/format";

/** DateTimeDisplay - relative time in the UI, exact ISO value on hover. */
export function renderRelativeTime(iso: string | null | undefined): HTMLElement {
  return el("span", { className: "tnum data-table__time", title: iso ?? undefined }, [relativeTime(iso)]);
}

/**
 * Absolute timestamp for dense tables - two fixed lines, exact ISO on hover:
 *   Sep 17, 2026
 *   11:25 AM IST
 *
 * Same layout for Started / Finished / Last Synced (and any other caller).
 */
export function renderAbsoluteTime(
  iso: string | null | undefined,
  options: AbsoluteTimeOptions = {}
): HTMLElement {
  const parts = absoluteTimeParts(iso, options);
  if (!parts) {
    return el("span", { className: "tnum data-table__datetime" }, [EMPTY]);
  }

  return el("span", { className: "tnum data-table__datetime", title: iso ?? undefined }, [
    el("span", { className: "data-table__datetime-date" }, [parts.date]),
    el("span", { className: "data-table__datetime-time" }, [parts.time]),
  ]);
}

/** DurationDisplay - started/finished -> human duration. */
export function renderDuration(startIso: string | null | undefined, endIso: string | null | undefined): HTMLElement {
  const text = startIso && endIso ? duration(startIso, endIso) : EMPTY;
  return el("span", { className: "tnum" }, [text]);
}
